/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlTextFieldAnswer
 */
export interface ControlTextFieldAnswer {
    /**
     * 
     * @type {string}
     * @memberof ControlTextFieldAnswer
     */
    field_type?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlTextFieldAnswer
     */
    text: string;
}

/**
 * Check if a given object implements the ControlTextFieldAnswer interface.
 */
export function instanceOfControlTextFieldAnswer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "text" in value;

    return isInstance;
}

export function ControlTextFieldAnswerFromJSON(json: any): ControlTextFieldAnswer {
    return ControlTextFieldAnswerFromJSONTyped(json, false);
}

export function ControlTextFieldAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlTextFieldAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'field_type': !exists(json, 'field_type') ? undefined : json['field_type'],
        'text': json['text'],
    };
}

export function ControlTextFieldAnswerToJSON(value?: ControlTextFieldAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'field_type': value.field_type,
        'text': value.text,
    };
}

